import { render, staticRenderFns } from "./CourseSessionEducators.vue?vue&type=template&id=24fb0398&scoped=true&"
import script from "./CourseSessionEducators.vue?vue&type=script&lang=ts&"
export * from "./CourseSessionEducators.vue?vue&type=script&lang=ts&"
import style0 from "./CourseSessionEducators.vue?vue&type=style&index=0&id=24fb0398&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24fb0398",
  null
  
)

export default component.exports